import React from 'react'
import styled from 'styled-components'
import Brand from 'helpers/brand'

import LegacyButton from 'components/LegacyButton'

import { color } from 'styles/colors'

import { SiteMessageDetail } from 'types/SiteMessageDetail'

type Props={
  title: string
  message: string
  siteMessages: Array<SiteMessageDetail>
  skipCallback: () => void
  nextCallback: () => void
}

const FeatureTourIntroCard = ({ title, message, siteMessages, skipCallback, nextCallback }: Props) => {
  return (
    <S.Container>
      <S.BrandLogo src={Brand.productLogoPath()} aria-label="brand-logo" alt={`${Brand.productLogoPath()} logo`} />
      <br />
      <div>
        <S.Heading>{title}</S.Heading>
        <ul>
          {
            siteMessages.map((siteMessage) => (
              <S.List key={siteMessage.id}>{siteMessage.title}</S.List>
            ))
          }
        </ul>
        <br />
        <S.HelpText>{message}</S.HelpText>
      </div>
      <S.ButtonContainer>
        <S.CancelButton type="button" variant="secondary" onClick={skipCallback} >Skip</S.CancelButton>
        <LegacyButton disabled={siteMessages.length === 0} type="button" variant="primary" onClick={nextCallback} >Next</LegacyButton>
      </S.ButtonContainer>
    </S.Container>
  )
}

export default FeatureTourIntroCard

const S = {
  Container: styled.div`
    padding: 20px;
  `,
  Heading: styled.h2`
    color: ${color('featureToursHeading')};
    margin-top: 25px;
  `,
  BrandLogo: styled.img`
    display: block;
    height: 80px;
    margin: auto;
  `,
  List: styled.li`
    color: ${color('primaryText')}
  `,
  HelpText: styled.p`
    color: ${color('primaryText')}
  `,
  ButtonContainer: styled.div`
    display: flex;
    justify-content: end;
    gap: 10px;
    margin-top: 20px;
  `,
  CancelButton: styled(LegacyButton)`
    border-color:  ${color('cancelButtonBorder')};
    color:  ${color('cancelButtonText')};

    &:hover{
    border-color:  ${color('cancelButtonHoverBorder')};
    color:  ${color('cancelButtonHoverText')};
    }
  `
}
